import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function FeedbackReport() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Feedback › Feedback Report</p>
                <h1>Feedback Report</h1>
                <p>Consolidated analysis of feedback received from all stakeholders.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>Feedback Analysis Summary</h2>
                    <p>The following report summarizes the feedback collected from students, teachers, parents, alumni, and employers during the academic year. The IQAC analyzes this feedback to identify areas for improvement and develop action plans.</p>
                    <table className="data-table" style={{ marginTop: '1rem' }}>
                        <thead><tr><th>Stakeholder</th><th>Feedback Type</th><th>Average Rating</th><th>Participants</th></tr></thead>
                        <tbody>
                            {[
                                ['Students', 'Teaching-Learning Process', '4.2 / 5', '—'],
                                ['Teachers', 'Institutional Support', '4.0 / 5', '—'],
                                ['Parents', 'Campus Facilities', '4.1 / 5', '—'],
                                ['Alumni', 'Overall Experience', '4.4 / 5', '—'],
                                ['Employers', 'Graduate Competency', '4.0 / 5', '—'],
                                ['Students', 'Library Services', '4.3 / 5', '—'],
                            ].map(([a, b, c, d], i) => <tr key={i}><td>{a}</td><td>{b}</td><td style={{ fontWeight: 700, color: '#2d6a4f' }}>{c}</td><td>{d}</td></tr>)}
                        </tbody>
                    </table>
                    <p style={{ fontSize: '0.85rem', color: '#999', marginTop: '0.8rem' }}>* Detailed reports are available with the IQAC. Contact <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a> for access.</p>
                </div>
                <div className="info-card">
                    <h2>Submit Feedback</h2>
                    <div className="ext-links">
                        {[['library', '📚 Library'], ['alumni', '🎓 Alumni'], ['employer', '💼 Employer'], ['parents', '👨‍👩‍👧 Parents'], ['student', '📝 Student'], ['teacher', '🧑‍🏫 Teacher']].map(([k, l]) => (
                            <a key={k} href={`/feedback/${k}`} className="ext-link-chip">{l}</a>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default FeedbackReport;
